import React, { useContext, useEffect, useMemo, useState } from 'react'
import Lang from '../Lang/Lang';
import {eventEmitter, hoverBtnClass, lang, analytics} from '../../common/baseData';
import {
  BasketContext,
  UserContext,
} from '../Context/ApplicationContextProvider';
import Icon from '../Icon/Icon';

function Product(props) {
  const {
    BASE_PRICE, BASE_PRICE_FORMATED, CORP_PRICE, CORP_PRICE_FORMATED, PROPERTY_CASHBACK_VALUE, last, itemKey, gaParams,
    ID, IMAGE_379_SRC, IS_NEW, IS_TOP, SPECIAL_DEAL, IS_INCLUDED_IN_DEAL, URL,
    DISCOUNT_TOTAL_PERCENT, DISCOUNT_TOTAL_PERCENT_FORMATED, CASHBACK_FORMATED, DIFF_FORMATED,
    PROPERTY_CML2_ARTICLE_VALUE, CREDIT_SERVICES, COLOR_OFFERS, PROPERTY_CH_MERCHANT_NAME, PROPERTY_NALICHIE_NAME,
    OLD_PRICE, OLD_PRICE_FORMATED, PRICE, PRICE_FORMATED, rootClassName,
  } = props;

  const {isCorpClient, wishlistItemIds} = useContext(UserContext);

  const basket = useContext(BasketContext);

  const [inBasket, setInBasket] = useState(Array.isArray(basket.products) &&
    basket.products.find((element, index) => {
      return Number(element.productId) === Number(ID);
    }) !== undefined);

  useEffect(() => {
    setInBasket(Array.isArray(basket.products) &&
    basket.products.find((element, index) => {
      return Number(element.productId) === Number(ID);
    }) !== undefined)
  }, [basket])

  const wishlistIdsSet = useMemo(() => {
    return new Set(Array.isArray(wishlistItemIds) ? wishlistItemIds.map(Number) : []);
  }, [wishlistItemIds]);

  const isInWishlist = wishlistIdsSet.has(Number(ID));

  const defaultRootClassName = `relative flex flex-col shrink-0 w-[220px] py-8 px-3.5 border ${!last
    ? 'border-r-0'
    : ''} border-solid border-grey-5 xl:basis-1/4 xl:max-w-[calc(25%-1px)] 2xl:basis-1/5 2xl:max-w-[calc(20%-1px)] desktop:px-5`;

  const title = props[`NAME_${lang.toUpperCase()}`];

  // определение финальной цены в зависимости от групп клиента
  const finalPrice = isCorpClient && CORP_PRICE && CORP_PRICE < PRICE ? CORP_PRICE : PRICE;
  const finalPriceFormated = isCorpClient && CORP_PRICE && CORP_PRICE < PRICE ? CORP_PRICE_FORMATED : PRICE_FORMATED;

  const basePrice = BASE_PRICE;
  const discount = basePrice - finalPrice;
  // форматируем скидку к общему виду с разделением по пробелам
  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };
  const discountFormated = `-${formatNumber(Math.round(discount))} ₴`;
  const discountPercent = discount > 0 ? Math.round((discount / basePrice) * 100) : 0;
  const discountPercentFormated = `- ${discountPercent} %`;

  const oldPriceDecoration = isCorpClient ? 'decoration-purple-corporate' : 'decoration-red-line-through'

  //console.info(title, basePrice, discount, discountPercent, finalPrice, finalPriceFormated);

  const onClick  = (item_id, url) => {
    analytics.selectItem(item_id, gaParams.item_list_name, gaParams.item_list_id)
    .then(response => {
      analytics.select_item(response.data.params);
      window.location.href = url
    })
    .catch(reason => {
      console.error(reason)
      window.location.href = url
    })
  }

  return (
    <li className={rootClassName ? rootClassName : defaultRootClassName}
        key={itemKey}>
      {!props.hideActions && (
        <>
          <a
            className="favorite-link absolute top-2 right-[47px] z-1 block border-0 opacity-50 hover:opacity-100 desktop:right-16"
            href="#"
            onClick={(event) => event.preventDefault()}>
            <i className="icon-favorite"
               data-container="favorite"
               data-id={ID}
               data-link="/personal/wishlist/"
               data-use="add">
            </i>
          </a>
          <a
            className="comparing-link absolute top-[9px] right-[14px] z-1 block border-0 opacity-50 hover:opacity-100 desktop:right-[20px]"
            href="#"
            onClick={(event) => event.preventDefault()}>
            <i className="icon-comparing"
               data-container="compare"
               data-id={ID}
               data-link="/personal/compare/"
               data-use="add">
            </i>
          </a>
        </>
      )}
      {
        discountPercent > 0 && (
          <span
            className="absolute top-2 left-[14px] z-1 bg-red-percent rounded-[14px] px-2 text-white text-[12px] leading-[20px] inline-block font-normal desktop:leading-[24px] desktop:top-2 desktop:left-[20px]">
                {discountFormated}
            </span>
        )
      }
      {/*<!-- картинка и лейблы -->*/}
      <div className="flex items-center justify-center relative">
        <a href={URL}
           onClick={(e) => {
             e.preventDefault();
             onClick(ID, URL);
           }}
           className="flex items-center justify-center desktop:w-[235px] desktop:h-[235px]">
          <img src={IMAGE_379_SRC}
               alt={title}
               width="230"
               height="230"
               loading="lazy"
               decoding="async"
               fetchpriority="low"
               className="object-fill w-full h-auto"/>
        </a>
        {/*<!-- акция -->*/
          SPECIAL_DEAL && SPECIAL_DEAL.hasOwnProperty('PICTURE') && (
            <img src={SPECIAL_DEAL.PICTURE.src}
                 loading="lazy"
                 decoding="async"
                 fetchpriority="low"
                 className="object-cover absolute bottom-0 left-0 h-10 w-10 desktop:w-14 desktop:h-14"/>
          )
        }
      </div>
      {/*<!-- наименование и артикул -->*/}
      <div className="mt-4 flex flex-col">
        <span className="truncate w-full overflow-hidden text-[11px] leading-[14px] h-[14px] text-grey-80">
            {PROPERTY_CML2_ARTICLE_VALUE}
        </span>
        <a href={URL}
           onClick={(e) => {
             e.preventDefault();
             onClick(ID, URL);
           }}
           className="text-[14px] font-normal leading-[18px] text-grey-90 line-clamp-3 h-[54px]">
          {title}
        </a>
      </div>
      {/*<!-- банки и цвета -->*/}
      <div className="mt-4 flex items-center h-6">
        <ul className="flex gap-1 justify-end min-h-[18px]" key={`offers-for-${itemKey}-${ID}`}>
          {
            COLOR_OFFERS && Array.isArray(COLOR_OFFERS) ?
              <>
                {
                  COLOR_OFFERS.length > 0 && (
                    COLOR_OFFERS.map((offer, index) => {
                      let updatedClassName = offer.CLASS_NAME.replace(/\s+/g, '');
                      return index < 5 ?
                        <li key={`offer-${itemKey}-${index}`}
                            className={`rounded-full w-[18px] h-[18px] ${updatedClassName}`}>
                          <a href={offer.URL}
                             onClick={(e) => {
                               e.preventDefault();
                               onClick(offer.URL, URL);
                             }}
                             className="w-full h-full inline-block"/>
                        </li> :
                        <></>;
                    })
                  )
                }
                {
                  COLOR_OFFERS.length > 5 && (
                    <span className="text-[12px] leading-[18px]"
                          key={`offer-${itemKey}-more`}>
                      {`+${COLOR_OFFERS.length - 5}`}
                  </span>
                  )
                }
              </> :
              <></>
          }
        </ul>
      </div>
      {/*<!-- стоимость и кнопка купить -->*/}
      <div className="mt-4 flex justify-between items-end flex-wrap gap-1">
        <div className="flex flex-col">
          {
              finalPrice > 0 && Number(BASE_PRICE) > 0 && Number(BASE_PRICE) > finalPrice && (
                <span className={`text-[12px] leading-[15px] h-[15px] line-through text-grey-50 ${oldPriceDecoration} desktop:text-[14px] desktop:leading-[17px] desktop:h-[17px]`}>
                    {BASE_PRICE_FORMATED}
                </span>
            )
          }
          {
            finalPrice > 0 && (
              <span
                className="text-[16px] leading-[20px] h-5 font-semibold text-grey-90 desktop:text-[20px] desktop:leading-[24px] desktop:h-6">
                  {finalPriceFormated}
              </span>
            )
          }
          {
            !(finalPrice > 0) &&
            (PROPERTY_NALICHIE_NAME === 'Ожидается' || PROPERTY_NALICHIE_NAME === 'Нет в наличии') && (
              <span className="available-status text-[14px] leading-[20px] font-normal text-grey-60 desktop:text-[16px]">
                {Lang.getMessage(PROPERTY_NALICHIE_NAME === 'Ожидается' ? 'productExpected' : 'productNotAvailable')}
              </span>
            )
          }
        </div>
        {
          PROPERTY_NALICHIE_NAME === 'В наличии' ?
            <button type="button"
                    onClick={() => {
                      if (inBasket) {
                        eventEmitter.emit('openSmallCart');
                      } else {
                        eventEmitter.emit('addToCart', {productId: Number(ID)});
                      }
                    }}
                    className={`flex items-center justify-center rounded-[14px] bg-blue-primary p-0 border-0 w-11 h-[37px] desktop:w-14 desktop:h-11 ${hoverBtnClass}`}>
              {
                inBasket ?
                  <Icon name={'in-cart-icon'}
                        className="h-[22px] w-[29px]"/> :
                  <Icon name={'add-to-cart-icon'}
                        className="h-[33px] w-[33px]"/>
              }
            </button> :
            <></>
        }

        {
          PROPERTY_NALICHIE_NAME === 'Ожидается' && (
            <a href="#"
               data-container="buy"
               data-product-id={ID}
               data-use="pre-order"
               className={`btn btn-block btn-border not-available-btn !py-[2px] !px-[8px] !h-[37px] desktop:!h-11 desktop:!py-[7px] desktop:!px-[14px]`}
               onClick={event => {
                 event.preventDefault();
                 eventEmitter.emit('preOrder', {productId: ID, productMerchant: PROPERTY_CH_MERCHANT_NAME})
               }}>
              <Icon name={'preorder-icon'} className="h-[25px] w-[25px]"/>
            </a>
          )
        }

        {
          PROPERTY_NALICHIE_NAME === 'Нет в наличии' && !isInWishlist ?
            <a href="#"
               data-container="buy"
               data-product-id={ID}
               data-use="report"
               data-wishlist-state={isInWishlist ? 'added' : 'default'}
               className={`btn btn-block btn-border not-available-btn !pt-[4px] !pb-[2px] !px-[8px] !h-[37px] desktop:!h-11 desktop:!pt-[10px] desktop:!pb-[7px] desktop:!px-[14px] ${isInWishlist ? 'active' : ''}`}
               onClick={event => {
                 event.preventDefault();
                 eventEmitter.emit('reportAvailability', {
                   productId: ID,
                   productMerchant: PROPERTY_CH_MERCHANT_NAME
                 });
               }}>
              <Icon name={'report-availability-icon'} className="h-[22px] w-[25px]"/>
            </a> :
          <></>
        }
      </div>
      {/*<!-- кешбек -->*/
        PROPERTY_CASHBACK_VALUE && PROPERTY_CASHBACK_VALUE > 0 && (
          <span className="mt-2 text-grey-90 text-[12px] leading-[15px] h-[15px]">
            {`${Lang.getMessage('cashback')} ${CASHBACK_FORMATED}`}
          </span>
        )
      }
    </li>
  );
}

export default Product;